import { FC, Fragment } from 'react';
import { Button, Col, Form, Input, Row, Table } from 'antd';
import FRMVisitReportAttendee from './VisitReportOfficePage.TechnicalAspect.Attendee';
import FRMVisitReportTechnicalAspectForm, {
	TechnicalAspectForm,
	useTechnicalAspectForm,
} from './VisitReportOfficePage.TechnicalAspect.Form';
import FRMVisitReportUnits from './VisitReportOfficePage.TechnicalAspect.Unit';
import FRMVisitReportPhotos from './VisitReportOfficePage.TechnicalAspect.Photo';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import { useFRMVisitReportPageContext } from './VisitReportOfficePage';
import FleetTitle from '@/libs/antd/components/Title';
import rule from '@/libs/antd/rules';
import { FormAlert, useFormAlert } from '@/libs/antd/form';

const FRMVisitReportTechnicalAspect: FC<{
	onSave: () => void;
}> = ({ onSave }) => {
	const { officeObservation, surveyInformation, approvalHistories } =
		useFRMVisitReportPageContext();
	const { technicalAspect } = officeObservation ?? {};
	const { technicalAspectForm, technicalAspectMutation } =
		useTechnicalAspectForm();

	const { alerts, validate } = useFormAlert(technicalAspectForm.form, null);

	return (
		<Form.Provider
			onFormFinish={async (name, { values }) => {
				if (!name) return;
				await technicalAspectMutation.mutateAsync({
					...(values as TechnicalAspectForm),
					surveyId: surveyInformation!.id!,
					unitDocumentFile: values.unitDocumentFile && {
						id: values.unitDocumentFile.id,
						name: values.unitDocumentFile.name,
						path: values.unitDocumentFile.path,
					},
				});
				onSave?.();
			}}
		>
			<FRMVisitReportAttendee />
			<FRMVisitReportTechnicalAspectForm
				technicalAspectForm={technicalAspectForm}
				technicalAspectMutation={technicalAspectMutation}
			/>
			<FRMVisitReportUnits />
			<FRMVisitReportPhotos />

			{approvalHistories?.length ? (
				<Fragment>
					<FleetTitle>Approval History</FleetTitle>
					<Table
						dataSource={
							approvalHistories?.map((record, key) => {
								return { ...record, key };
							}) ?? []
						}
						columns={[
							{
								title: 'No',
								width: 1,
								align: 'center',
								dataIndex: 'no',
							},
							{
								title: 'Name',
								dataIndex: 'approvalBy',
							},
							{
								title: 'Date',
								dataIndex: 'approvalDate',
							},
							{
								title: 'Process',
								dataIndex: 'approvalProcess',
							},
							{
								title: 'Status',
								align: 'center',
								render: (_, record) => {
									return (
										<span
											className={`review-status ${record.approvalStatus.toLowerCase()}`}
										>
											{record.approvalStatus}
										</span>
									);
								},
							},
							{
								title: 'Approval Notes',
								dataIndex: 'approvalNote',
							},
						]}
						bordered
						pagination={false}
						style={{ marginBottom: 20 }}
					/>
				</Fragment>
			) : null}

			<Form
				{...ANTD_DEFAULT_PROPS.FORM}
				name="technicalAspectNotes"
				form={technicalAspectForm.form}
				labelCol={{
					span: 10,
				}}
				initialValues={
					{
						technicalAspectNotes: technicalAspect?.technicalAspectNotes,
					} as TechnicalAspectForm
				}
			>
				<FormAlert alerts={alerts} />
				<Row gutter={[20, 40]}>
					<Col span={24}>
						<Form.Item
							name={technicalAspectForm.fieldName('technicalAspectNotes')}
							label="Informasi Tambahan"
							labelCol={{
								span: 6,
								style: {
									alignSelf: 'center',
								},
							}}
							wrapperCol={{
								style: {
									marginLeft: -5,
								},
							}}
							rules={[rule.required('Informasi Tambahan wajib diisi')]}
						>
							<Input.TextArea rows={4} />
						</Form.Item>
					</Col>
				</Row>
			</Form>

			<Button
				type="primary"
				loading={technicalAspectMutation.isPending}
				style={{
					width: 200,
					display: 'block',
					marginLeft: 'auto',
					marginTop: 30,
				}}
				onClick={() => {
					validate();
					technicalAspectForm.form.submit();
				}}
			>
				SAVE
			</Button>
		</Form.Provider>
	);
};

export default FRMVisitReportTechnicalAspect;
